import { I18n } from '@app/i18n/strings-keys';
import { IErrorPageType } from '@shared/types';

export const NOT_PERMITTED_ERROR_PAGE_TEMPLATE: IErrorPageType = {
  title: I18n.ErrorMessages.NotPermitted,
  icon: 'glyphicon-minus-sign',
  description: I18n.ErrorMessages.YouAreNotPermittedToDoThis,
};

export const GENERIC_ERROR_PAGE_TEMPLATE: IErrorPageType = {
  title: I18n.ErrorMessages.UnexpectedError,
  icon: 'glyphicon-remove-sign',
  description: I18n.ErrorMessages.UnexpectedErrorOccurs,
};

export const NOT_FOUND_ERROR_PAGE_TEMPLATE: IErrorPageType = {
  title: I18n.ErrorMessages.Page404,
  icon: 'glyphicon-minus-sign',
  description: I18n.ErrorMessages.ThePageYouAreLookingForCannotBeFound,
};

export const COMPANY_PREFERENCES_IS_MISSING: IErrorPageType = {
  title: I18n.ErrorMessages.CanNotReceivePreferencesForCurrentCompany,
  icon: 'glyphicon-warning-sign',
  description: I18n.ErrorMessages.SomeRoutesCanNotBeUnreachable,
  redirectText: I18n.ErrorMessages.GoToCompanyPreferencesAndTrySave,
  redirectLink: '/preferences/defaults',
};

export const API_TIMEOUT_ERROR_PAGE_TEMPLATE: IErrorPageType = {
  title: I18n.ErrorMessages.API_REQUEST_TIMEOUT,
  icon: 'glyphicon-alert',
  description: I18n.ErrorMessages.XVIAPIRequestError,
};

export const USER_DOES_NOT_HAVE_SITES: IErrorPageType = {
  title: I18n.ErrorMessages.NotAssignedToSites,
  icon: 'glyphicon-warning-sign',
  description: I18n.ErrorMessages.SiteAssignmentRequired,
};
